import { createEffect } from 'effector';
import { api } from '../../api/axiosInstance.js';

export const createProjectFx = createEffect().use(
  async (payload) => (await api().post('/project/', payload)).data
);

export const getProjectByIdFx = createEffect().use(async (id) => {
  return (await api().get(`/project/${id}`)).data;
});

export const getParticipantsFx = createEffect().use(async (bin) => {
  return (
    await Promise.all([
      ...bin.map((id) => api().get(`/organization/gov/${id}`)),
    ])
  ).map((res) => res.data);
});

export const updateProjectFx = createEffect().use(
  async ({ id, values }) => (await api().put(`/project/${id}`, values)).data
);

export const deleteProjectFx = createEffect().use(
  async (id) => (await api().delete(`/project/${id}`)).data
);

export const publishProjectFx = createEffect().use(
  async (id) => (await api().post(`/project/publish/${id}`)).data
);

export const rollbackProjectFx = createEffect().use(
  async (id) => (await api().post(`/project/rollback/${id}`)).data
);

export const pausePhaseFx = createEffect().use(
  async ({ project_id, phase_id }) =>
    (await api().patch(`/project/${project_id}/phases/${phase_id}/pause`)).data
);

export const completePhaseFx = createEffect().use(
  async ({ project_id, phase_id }) =>
    (await api().patch(`/project/${project_id}/phases/${phase_id}/complete`))
      .data
);

export const inProgressPhaseFx = createEffect().use(
  async ({ project_id, phase_id }) =>
    (await api().patch(`/project/${project_id}/phases/${phase_id}/in_progress`))
      .data
);
